import { render, staticRenderFns } from "./Routes.vue?vue&type=template&id=45a0b3cf&scoped=true&"
import script from "./Routes.vue?vue&type=script&lang=js&"
export * from "./Routes.vue?vue&type=script&lang=js&"
import style0 from "./Routes.vue?vue&type=style&index=0&id=45a0b3cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a0b3cf",
  null
  
)

export default component.exports